export default "__VITE_ASSET__QNnLT4sK__"